import PropTypes from 'prop-types';
import "./VariantCard.scss";
import { Iconify, Button } from "@repo/design-system/components/ui";
import { StatusOverflow } from "../status/common";

export const VariantCard = ({
    chIcon, chTitle, chDescription,
    children, cfTitle,
    headerIconWidth,
    className = "", customButton = [] }) => {
    return (
        <div className={`variantCard ${className}`}>
            <div className='variantCard-container'>
                {(chTitle || chDescription) &&
                    <div className='variantCard-header'>
                        <div className='variantCard-header-contect'>
                            {chIcon && <div className='variantCard-header-icon'>
                                <Iconify icon={chIcon} width={headerIconWidth} />
                            </div>
                            }
                            <div className='variantCard-header-text-container'>
                                {chTitle &&
                                    <h5 className='variantCard-header-title'>
                                        <StatusOverflow label={chTitle} />
                                    </h5>
                                }
                                {chDescription &&
                                    <div className='variantCard-header-description'>
                                        <StatusOverflow label={chDescription} />
                                    </div>
                                }
                            </div>
                        </div>
                        {customButton && customButton.length > 0 &&
                            <div className="variantCard-button">
                                {customButton?.map((btn, index) => (
                                    <Button key={index} className={`variantCard-header-custom-btn ${btn?.className}`}
                                        variant={btn?.variant} ttLabel={btn?.ttLabel} targetId={btn?.targetId}
                                        onClick={btn?.onClick} leftIcon={btn?.leftIcon} size={btn?.size}
                                        rightIcon={btn?.rightIcon} iconWidth={btn?.iconWidth}>
                                        {btn?.label}
                                    </Button>
                                ))}
                            </div>
                        }
                    </div>
                }
                {children}
            </div>
            {cfTitle && <div className='variantCard-footer'>
                <h6 className='variantCard-footer-title'>{cfTitle}</h6>
            </div>
            }
        </div >
    );
};

VariantCard.propTypes = {
    chIcon: PropTypes.string,
    chTitle: PropTypes.node,
    chDescription: PropTypes.node,
    children: PropTypes.node,
    cfTitle: PropTypes.string,
    headerIconWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    className: PropTypes.string,
    customButton: PropTypes.array
};